import { useState } from 'react'
import { useForm } from 'react-hook-form'

import { logisticCartApi } from 'redux/services/logistic-cart'
import { UpdateLogisticCartStatus } from 'redux/services/logistic-cart/types'

import { AppButton } from 'components/AppButton'
import { AppModal } from 'components/AppModal'
import { TextField } from 'components/TextField'

import { LOGISTIC_CART_STATUS_TEXT } from 'constants/logistic-cart'
import { LogisticCartStatus } from 'models/logistic_cart'

import styles from './UpdateStatus.module.scss'

const labels: Record<LogisticCartStatus, string> = {
  [LogisticCartStatus.in_process]: 'В работу',
  [LogisticCartStatus.error]: 'На уточнение',
  [LogisticCartStatus.waiting]: 'В ожидание',
  [LogisticCartStatus.given]: 'Закрыть',
  [LogisticCartStatus.denied]: 'Отклонить',
}

interface Props {
  id: number
  status: LogisticCartStatus
}
export function UpdateStatus({ id, status }: Props) {
  const [open, setOpen] = useState(false)
  const updateSatusForm = useForm<UpdateLogisticCartStatus>({
    defaultValues: {
      id,
      body: {
        status,
      },
    },
  })
  const [updateSatus, updateSatusState] =
    logisticCartApi.useUpdateLogisticCartStatusMutation()

  function onSubmitUpdateStatus(values: UpdateLogisticCartStatus) {
    updateSatus(values)
      .unwrap()
      .then(() => {
        setOpen(false)
      })
  }

  return (
    <>
      <AppButton variant="siren_dashed_border" onClick={() => setOpen(true)}>
        {labels[status]}
      </AppButton>
      {open && (
        <AppModal onClose={() => setOpen(false)} title={`Сменить статус`}>
          <form
            className={styles.container}
            onSubmit={updateSatusForm.handleSubmit(onSubmitUpdateStatus)}
          >
            <TextField
              // label="Статус"
              value={LOGISTIC_CART_STATUS_TEXT[status]}
              disabled
            />

            <br />

            <TextField
              {...updateSatusForm.register('body.comment')}
              label="Комментарий"
              withError
              error={updateSatusForm.formState.errors.body?.comment?.message}
            />

            <AppButton disabled={updateSatusState.isLoading} type="submit">
              Принять
            </AppButton>
          </form>
        </AppModal>
      )}
    </>
  )
}
